"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const styles = require('./NavigationListMenuItem.module.scss');
const NavigationListMenuItem = ({ children, className = '', showDivider = true, }) => (react_1.default.createElement("li", { className: (0, classnames_1.default)(styles.root, {
        [styles.divider]: showDivider,
        [className]: !!className,
    }) }, children));
exports.default = NavigationListMenuItem;
//# sourceMappingURL=NavigationListMenuItem.js.map